/* eslint-disable camelcase */
import React from "react";
import { useAppState } from "hooks/AppContext";
import { CompanyDetails } from "components/CompanyDetails";
import { Perks } from "components/Perks";
import styles from "./Sidebar.module.scss";

const Sidebar = () => {
    const { company } = useAppState();
    const {
        short_description,
        perks_and_benefits,
        employee_range,
        industries,
    } = company;
    return (
        <>
            <div className={styles.sidebar}>
                <p className={styles.description}>{short_description}</p>
                <CompanyDetails {...{ employee_range, industries }} />
            </div>
            <Perks {...{ perksAndBenefits: perks_and_benefits }} />
        </>
    );
};
Sidebar.displayName = "Sidebar";

export { Sidebar };
